<template>
  <v-dialog v-model="dialog" width="500">
    <v-card>
      <gg-toolbar @close="close">
        Key Generation Complete!
      </gg-toolbar>

      <v-card-text>
        <v-textarea outlined :value="reason" readonly hide-details rows="8"></v-textarea>
      </v-card-text>
      <v-card-actions>
        <gg-btn class="mb-0 ml-0" @click="close" text color="green">Close</gg-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import modalMixin from '@/mixins/modal'

export default {
  name: 'KeyGeneratedModal',
  mixins: [modalMixin],
  props: {
    reason: {
      type: String,
      required: true,
    }
  },
  data () {
    return {}
  }
}
</script>
